import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend, Title } from 'chart.js';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend, Title);

const HistoryDateHistogram = ({ summary = [], totalStocks = 0, stocksWithoutHistory = 0, loading = false }) => {
    if (loading) return <div className="card p-3 mt-3">Loading history-date summary…</div>;

    const data = {
        labels: summary.map(({ date }) => date),
        datasets: [{
            label: 'Stocks',
            data: summary.map(({ count }) => count),
            backgroundColor: '#0d6efd',
            borderRadius: 4,
        }],
    };
    const options = {
        responsive: true,
        plugins: {
            legend: { display: false },
            title: { display: true, text: 'Stocks grouped by latest history date' },
            tooltip: {
                callbacks: {
                    label: (context) => `${context.parsed.y} stocks`,
                    afterLabel: (context) => {
                        const { companyIds = [] } = summary[context.dataIndex] || {};
                        if (!companyIds.length) return '';
                        const displayedIds = companyIds.slice(0, 20).join(', ');
                        const remainingCount = companyIds.length - 20;
                        return `Company IDs: ${displayedIds}${remainingCount > 0 ? ` (+${remainingCount} more)` : ''}`;
                    },
                },
            },
        },
        scales: {
            x: { title: { display: true, text: 'Latest date in CSV history' } },
            y: { beginAtZero: true, ticks: { precision: 0 }, title: { display: true, text: 'Stock count' } },
        },
    };

    return (
        <div className="card p-3 mt-3">
            <div className="d-flex justify-content-between flex-wrap mb-2">
                <strong>History file freshness</strong>
                <span>Total: {totalStocks} · No history file: {stocksWithoutHistory}</span>
            </div>
            {summary.length ? <Bar data={data} options={options} /> : <div>No history dates were found.</div>}
        </div>
    );
};

export default HistoryDateHistogram;
